// Validated 8-hue categorical palette (light-surface variant of the
// dataviz-skill reference palette — this app has no dark theme). The order
// is the CVD-safety mechanism (maximizes adjacent color separation), so
// don't reorder or resize this array without re-validating.
export const SCORE_COLOR_PALETTE = [
  '#2a78d6', // blue
  '#1baf7a', // aqua
  '#eda100', // yellow
  '#008300', // green
  '#4a3aa7', // violet
  '#e34948', // red
  '#e87ba4', // magenta
  '#eb6834', // orange
];

/**
 * Color for a score: the user's explicit `ScoreDefinition.color` if they've
 * set one, otherwise a deterministic fallback from the position in
 * `scoreDefinitions` — stable everywhere scores render (juror cards, pool
 * rows, data view) as long as the list keeps its order. Position-based
 * (not id-based) so no separate color-assignment table needs to be stored
 * or migrated for scores nobody has customized.
 */
export function getScoreColor(scoreDefinitionId, scoreDefinitions) {
  const definitions = scoreDefinitions || [];
  const index = definitions.findIndex((s) => s._id === scoreDefinitionId);
  const explicitColor = index >= 0 ? definitions[index]?.color : null;
  if (explicitColor) {
    return explicitColor;
  }
  return SCORE_COLOR_PALETTE[(index >= 0 ? index : 0) % SCORE_COLOR_PALETTE.length];
}

export default { getScoreColor, SCORE_COLOR_PALETTE };
